module.exports = __webpack_public_path__ + "img/11_Kombipaket-Preis.609f7080.svg";